<template>
  <div class="banner">
    <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
      <ol class="carousel-indicators">
        <li v-for="(value, index) in data" :key="index" data-target="#carouselExampleIndicators" :data-slide-to=index v-bind:class="{'active': index == 0}" ></li>
      </ol>
      <div class="carousel-inner">
        
        <div  v-for="(value, index) in data" :key="index" class="carousel-item" v-bind:class="{'active': index == 0}">
          <img :src=value.cover />
          <div class="carousel-div-info">
            <h1>{{value.title}}</h1>
            <p>{{value.description}}</p>
          </div>
        </div>
      </div>
      <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </div>
</template>

<script>

import SlideShow from '@/parse/models/SlideShow';

export default {
  name: 'banner',
  data () {
    return {
      data: {},
    }
  },
  beforeMount(){
    SlideShow.load()
    .then((slide) => this.data = slide)
    .catch(error => console.log(error))
  }
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.carousel-item{
  max-height: 657px;
}

.carousel-indicators {
  margin: 25px;
}

.carousel-indicators li {
  width: 33.33333%;
  margin: 0;
  height: 1;
  
}

.carousel-item img {
  width: 100%;
  position: relative;
}

.carousel-control-prev {
  right: 0;
  margin-top: 50px;
  left: initial;
}

.carousel-control-next, .carousel-control-prev {
  background: #fff;
  border: 1px solid #fff;
  width: 40px;
  height: 40px;
  opacity: 1;
  top: 20px;
  margin-right: 20px;
}

.carousel-control-next-icon{
  background: url('../assets/images/right.png');
  background-repeat: no-repeat;
  background-position: center;
}

.carousel-control-prev-icon{
  background: url('../assets/images/left.png');
  background-repeat: no-repeat;
  background-position: center;
}

.carousel-div-info {
  position: absolute;
  width: 100%;
  bottom: 0;
  right: 0;
  text-align: left;
  padding: 25px;
  color: #fff;
  margin-bottom: 25px;
}

.carousel-div-info h1{
  font-size: 25px;
  font-family: 'plain regular', arial;
  margin-bottom: 30px;
}

.carousel-div-info p{
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 50px;
}

.ctrl-action{
  color: #fff;
  font-size: 10px;
  font-family: 'plain regular', arial;
  text-decoration: none;
  font-weight: 600;
}

.ctrl-action img{
  width: 25px;
  margin-top: -3px;
  padding-left: 5px;
}


/* Mobile first queries */

/* Larger than Desktop HD */
@media (max-width: 1280px) {}

/* Larger than desktop */
@media (max-width: 992px) {

  .carousel-div-info {
    padding: 25px 25px 25px 16px;
  }

  .carousel-div-info p{
    font-size: 16px;
  }
}

/* Larger than tablet */
@media (max-width: 768px) {
  .carousel-control-prev{
    display: none;
  }

  .carousel-control-next{
    display: none;
  }
  
  .carousel-div-info p{
    font-size: 15px;
    line-height: 22px;
    margin-bottom: 5px;
  }

  .carousel-div-info {
    padding: 25px 25px 25px 16px;
  }

  .carousel-div-info h1{
    margin-bottom: 10px;
  }

}

/* Larger than phablet */
@media (max-width: 550px) {
  .carousel-div-info p{
    font-size: 12px;
  }
  .carousel-div-info p{
    height: 50px;
    overflow: hidden;
  }
  
  .info-form-contact h1{
    font-size: 12px;
  }
  
  .info p{
    font-size: 12px;
  }
}

/* Larger than mobile */
@media (max-width: 400px) {}


</style>
